module.exports = __webpack_public_path__ + "static/img/伙伴客户-美亚.dec2df52.png";